export default __webpack_public_path__ + "static/media/SB_logo_small.3a5aabb3.svg";